AngularApplication = require('resources/assets/coffee/Core/AngularApplication').AngularApplication
Socket = require('resources/assets/coffee/Core/Socket').Socket

class exports.CoreApp extends AngularApplication
    init: () ->
        # By default, route us to '/'.
        # This corresponds to the 'default' state that is
        # specified in MainRouter. It doesn't do anything. Just
        # there for some backwards compatibility-ness
        # while we convert everything to angularity.
        @angular_default_route = '/'

        @addAngularRoutes([
            { path: 'core::Angular/NavigationRouter' }
            { path: 'core::Angular/UsernameDropdownRouter' }
            # core

            { path: 'grower::Angular/MainRouter' }
            { path: 'grower::Angular/AdvisorRequest/Router' }
            { path: 'grower::Angular/Data/DataRouter' }
            { path: 'grower::Angular/Data/PlantingRx/PlantingRxRouter' }
            { path: 'grower::Angular/Fields/FieldsRouter' }
            { path: 'grower::Angular/Fields/Define/DefineRouter' }
            { path: 'grower::Angular/Placement/PlacementRouter' }
            { path: 'grower::Angular/Profile/ProfileRouter' }
            { path: 'grower::Angular/Contacts/ContactsRouter' }
            { path: 'grower::Angular/Fieldprint/FieldprintRouter' }
            { path: 'grower::Angular/BuyerLocation/Router' }
            # grower

            { path: 'portal::Angular/Account/AccountRouter' }
            { path: 'portal::Angular/Zones/ZonesRouter' }
            { path: 'portal::Angular/Weightings/WeightingsRouter' }
            { path: 'portal::Angular/Hybrids/HybridsRouter' }

            { path: 'portal::Angular/Daystoharvest/DaystoharvestRouter' }
            { path: 'portal::Angular/Ratings/RatingsRouter' }
            { path: 'portal::Angular/KeyFields/KeyFieldsRouter' }
            { path: 'portal::Angular/KeyFieldsDefine/KeyFieldsDefineRouter' }
            { path: 'portal::Angular/Contracts/ContractsRouter' }
            { path: 'portal::Angular/Convert/ConvertRouter' }
            { path: 'portal::Angular/Delivery/DeliveryRouter' }
            { path: 'portal::Angular/Communicate/CommunicateRouter' }
            { path: 'portal::Angular/Koz/KozRouter' }
            { path: 'portal::Angular/QbUsers/QbUsersRouter' }
            { path: 'portal::Angular/Audit/AuditRouter' }
            { path: 'portal::Angular/OnFarmStorage/OnFarmStorageRouter' }
            { path: 'portal::Angular/QBQ/QBQRouter' }
            { path: 'portal::Angular/Customers/PortalCustomersRouter' }
            # portal

            { path: 'admin::Angular/Inserter/InserterRouter' }
            { path: 'admin::Angular/Tools/ToolsRouter' }
            { path: 'admin::Angular/Preferences/PreferencesRouter' }
            { path: 'admin::Angular/Funsies/FunsiesRouter' }
            # admin
        ])

        @addAngularServices([
            'grower::Services/TruthStripToolbar'
        ])

        window.Socket = new Socket()

        self = this

    initAngular: () =>
        super()

        SafeLinkController = @loadClass('grower::Angular/SafeLinkController')
        Service = @loadClass('grower::Angular/SafeLinkService')

        @angularApp.service 'SafeLinkService', ['$http', '$rootScope', Service]
        @angularApp.controller 'SafeLinkController', [
            '$scope'
            '$transitions'
            'SafeLinkService'
            'Core.Services.Session'
            SafeLinkController
        ]

        UsernameDropdownController = @loadClass('core::Angular/UsernameDropdown/MainController')
        @angularApp.controller 'UsernameDropdownController', [
            '$scope'
            '$transitions'
            '$uibModal'
            UsernameDropdownController
        ]

    initMap: () =>
        undefined
